"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectedIndicator = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
const common_1 = require("@/components/common");
/**
 * 선택 상태를 나타내는 장식용 체크 표시.
 * 선택 상호작용과 aria 상태는 행(옵션·메뉴 항목)이 소유하고, 이 요소는 selected 상태만 받아 체크 노출로 반영한다.
 * 선택되지 않아도 자리를 유지해 목록의 행마다 트레일링 폭이 같게 한다.
 */
let SelectedIndicator = class SelectedIndicator extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.selected = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('aria-hidden', 'true');
    }
    render() {
        return (0, lit_1.html) `
      <mm-icon name=${common_1.ICON_NAMES.CHECK}></mm-icon>
    `;
    }
};
SelectedIndicator.styles = (0, lit_1.css) `
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: var(--size-24);
      height: var(--size-24);
    }

    mm-icon {
      visibility: hidden;
    }

    :host([selected]) mm-icon {
      visibility: visible;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], SelectedIndicator.prototype, "selected", void 0);
SelectedIndicator = __decorate([
    (0, decorators_js_1.customElement)('mm-selected-indicator')
], SelectedIndicator);
exports.SelectedIndicator = SelectedIndicator;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VsZWN0ZWQtaW5kaWNhdG9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic2VsZWN0ZWQtaW5kaWNhdG9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBMkQ7QUFFM0QsK0JBQTRCO0FBQzVCLGdEQUFnRDtBQUVoRDs7OztHQUlHO0FBRUksSUFBTSxpQkFBaUIsR0FBdkIsTUFBTSxpQkFBa0IsU0FBUSxnQkFBVTtJQUExQzs7UUFrQnVDLGFBQVEsR0FBRyxLQUFLLENBQUE7SUFZOUQsQ0FBQztJQVZDLGlCQUFpQjtRQUNmLEtBQUssQ0FBQyxpQkFBaUIsRUFBRSxDQUFBO1FBQ3pCLElBQUksQ0FBQyxZQUFZLENBQUMsYUFBYSxFQUFFLE1BQU0sQ0FBQyxDQUFBO0lBQzFDLENBQUM7SUFFRCxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTtzQkFDTyxtQkFBVSxDQUFDLEtBQUs7S0FDakMsQ0FBQTtJQUNILENBQUM7O0FBNUJNLHdCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7R0FnQmxCLENBQUE7QUFDMkM7SUFBM0MsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7bURBQWlCO0FBbEJqRCxpQkFBaUI7SUFEN0IsSUFBQSw2QkFBYSxFQUFDLHVCQUF1QixDQUFDO0dBQzFCLGlCQUFpQixDQThCN0I7QUE5QlksOENBQWlCIn0=